import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import WidowhoodForm from './form';
import {
  NewPersonVM,
  AccordionWidowhood,
} from 'shell/components/shared/sipo-person-form/new-person';

const WidowhoodComponent = (): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(false);

  const formContext = useFormikContext<NewPersonVM>();

  const onFieldWidowhoodChange = useEventCallback(
    (key: keyof AccordionWidowhood, value: AccordionWidowhood[keyof AccordionWidowhood]) => {
      formContext.setFieldValue('widowhood', {
        ...formContext.values.widowhood,
        [key]: value,
      });
    }
  );

  const onFieldsWidowhoodChange = useEventCallback((values: AccordionWidowhood) => {
    formContext.setFieldValue('widowhood', {
      ...formContext.values.widowhood,
      ...values,
    });
  });

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-widowhood-content"
        id="panel-person-widowhood-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>
          Vedovanza
          {formContext?.errors?.widowhood && formContext?.touched?.widowhood ? (
            <Typography style={{ color: '#d6012e', display: 'inline', paddingLeft: '10px' }}>
              Attenzione verificare dati errati o mancanti
            </Typography>
          ) : undefined}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <WidowhoodForm
          values={formContext.values.widowhood}
          onChange={onFieldWidowhoodChange}
          onChangeValues={onFieldsWidowhoodChange}
          errors={formContext.errors.widowhood as FormikErrors<AccordionWidowhood>}
          touched={formContext.touched.widowhood as unknown as FormikTouched<AccordionWidowhood>}
        />
      </AccordionDetails>
    </Accordion>
  );
};

WidowhoodComponent.displayName = 'Accordion widowhood component';

const Widowhood = memo(WidowhoodComponent);

export default Widowhood;
